export default __webpack_public_path__ + "static/media/ITRealCase3-en.792d382a.jpg";